function updateMenuMargin() {
    const header = document.querySelector('.header-sticky');
    const menu = document.getElementById('fullscreenMenu');
    if (header && menu) {
        const headerHeight = header.offsetHeight;
        menu.style.marginTop = `${headerHeight}px`;
    }
}

// Initialisierung beim Laden der Seite
document.addEventListener('DOMContentLoaded', updateMenuMargin);

// Aktualisierung bei Größenänderung des Fensters
window.addEventListener('resize', updateMenuMargin);

// Modifizieren Sie die toggleMenu Funktion
function toggleMenu() {
    const header = document.querySelector('.site-header');
    const menu = document.getElementById('fullscreenMenu');
    const button = document.getElementById('menuToggle');
    const expanded = button.getAttribute('aria-expanded') === 'true';

    header.classList.toggle('menu-open');
    menu.classList.toggle('open');
    button.classList.toggle('open');
    button.setAttribute('aria-expanded', !expanded);
    menu.setAttribute('aria-hidden', expanded);

    // Margin aktualisieren, wenn das Menü geöffnet wird
    updateMenuMargin();
}

function toggleSubmenu(button) {
    const submenu = document.getElementById(button.getAttribute('aria-controls'));
    const expanded = button.getAttribute('aria-expanded') === 'true';
    submenu.classList.toggle('open');
    button.classList.toggle('open');
    button.setAttribute('aria-expanded', !expanded);
    submenu.setAttribute('aria-hidden', expanded);
}

document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        const menu = document.getElementById('fullscreenMenu');
        const button = document.getElementById('menuToggle');
        menu.classList.remove('open');
        menu.setAttribute('aria-hidden', 'true');
        button.classList.remove('open');
        button.setAttribute('aria-expanded', 'false');
    }
});

// Event-Listener hinzufügen
document.getElementById('menuToggle').addEventListener('click', toggleMenu);

const arrowButtons = document.querySelectorAll('.arrow-button');
arrowButtons.forEach(button => {
    button.addEventListener('click', () => toggleSubmenu(button));
});
